/**
 * TODO: Replace "reakit/Disclosure" with "ariakit".
 * Can't do this yet because `SettingsSectionTrigger` is a public component and used in ui-app-platform.
 */
import { Disclosure } from "reakit/Disclosure";
import styled from "styled-components";
import { Text } from "./Text";
import { mediaQueries, style } from "./style";
import { focusOutline } from "./utils/focusOutlineStyle";

const TRIGGER_COL_WIDTH = "120px"; // width of column for open/close button

export const FullWidthSettingsSection = styled.div`
  border-bottom: ${style.vars.borderWidth.thin} solid ${style.colors.grey.light};
  margin-bottom: ${style.vars.whitespace.medium};
  padding-bottom: ${style.vars.whitespace.regular};
`;

export const SettingsSectionExpandableRow = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const SettingsSectionTitle = styled(Text).attrs({ type: "h4" })`
  flex: 0 0 100%;
  flex-shrink: 1;
  padding-right: 1%;
  max-width: calc(100% - ${TRIGGER_COL_WIDTH});

  ${mediaQueries.mediumMin} {
    max-width: 25%;
  }
`;

export const SettingsSectionCollapsedDescription = styled.div`
  color: ${style.colors.grey.dark};
  flex: 0 0 100%;
  margin: 0;
  margin-bottom: ${style.vars.whitespace.regular};
  max-width: calc(100% - ${TRIGGER_COL_WIDTH});
  order: 3;

  ${mediaQueries.mediumMin} {
    max-width: 50%;
    order: 2;
  }
`;

export const SettingsSectionTriggerWrapper = styled.div`
  flex: 0 0 100%;
  justify-content: flex-end;
  margin-bottom: ${style.vars.whitespace.regular};
  order: 2;
  text-align: right;
  transition: color ${style.vars.transitionSpeed.base} ${style.vars.easeInOutCubic};
  max-width: ${TRIGGER_COL_WIDTH};

  ${mediaQueries.mediumMin} {
    max-width: 25%;
    order: 3;
  }
`;

export const SettingsSectionTrigger = styled(Disclosure)`
  background: none;
  border: none;
  color: ${style.colors.blue.dark};
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  font-weight: ${style.vars.fontWeight.bold};
  margin-right: 0;

  &:active,
  &:hover {
    color: ${style.colors.blue.primary};
    text-decoration: underline;
  }

  &:focus {
    ${focusOutline()};
  }
`;
